export { CompanyDetail } from '@/components/demographics/companyDetail'
export { CompanyList } from './list'



// WEBPACK FOOTER //
// ./src/internal-app/pages/companies/index.js